import "react-toastify/dist/ReactToastify.css";

export const toastProperties = {
  position: "top-right",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  progress: undefined,
  theme: "colored",
  zIndex: 99999,
};
